module.exports = __webpack_public_path__ + "f92e81f2f55f2172246aaa6e91926323.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/Stroke-Gap-Icons/Stroke-Gap-Icons.woff
 ** module id = ./src/styles/fonts/Stroke-Gap-Icons/Stroke-Gap-Icons.woff
 ** module chunks = 0
 **/